import styled from 'styled-components'

export const Section = styled.section`
  width: 100%;
  background: #fff;
  margin-top: 124px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 18px;
`

export const Title = styled.h2`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 36px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  color: #21105d;
  margin-bottom: 40px;
  @media (max-width: 600px) {
    font-size: 24px;
  }
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 40px;
  justify-content: center;
  width: 100%;
  max-width: 1200px;
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
    gap: 32px;
  }
`

export const ImageCol = styled.div`
  flex: 1 1 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 280px;
  @media (max-width: 900px) {
    min-width: unset;
    width: 100%;
    margin-bottom: 24px;
  }
`

export const TextCol = styled.div`
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  gap: 48px;
  min-width: 280px;
  max-width: 600px;
  color: #21105d;
  @media (max-width: 900px) {
    min-width: unset;
    max-width: unset;
    width: 100%;
  }
  @media (max-width: 600px) {
    gap: 12px;
    align-items: flex-start;
  }
`

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`

export const BlockTitle = styled.b`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 21px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #21105d;
  @media (max-width: 600px) {
    font-size: 16px;
  }
`

export const BlockText = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #21105d;
  @media (max-width: 600px) {
    font-size: 12px;
    line-height: 18px;
  }
`

export const ImageClickable = styled.div`
  cursor: pointer;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
  border-radius: 16px;
  display: inline-flex;

  &:hover {
    transform: scale(1.02);
    box-shadow: 0 8px 32px rgba(80, 57, 221, 0.18);
  }
`

export const ViewerWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 547px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(80, 57, 221, 0.18);
`

export const ViewerCloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: rgba(33, 16, 93, 0.85);
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;

  &:hover {
    background: #5039dd;
  }
`
